import type { IShopBoard, IShopBoardItem, IShopOrderCard } from '../redux/shop'

function mergeItems(items: IShopBoardItem[]): IShopBoardItem[] {
  const byProduct = new Map<string, IShopBoardItem>()

  for (const item of items) {
    const existing = byProduct.get(item.productId)
    if (existing) {
      existing.quantity += item.quantity
    } else {
      byProduct.set(item.productId, { ...item })
    }
  }

  return Array.from(byProduct.values())
}

/** One pickup card per patient; duplicate SKUs across orders merged (e.g. Turmeric ×2). */
export function mergePickupBoardByPatient(board: IShopBoard): IShopBoard {
  const byPatient = new Map<string, IShopOrderCard>()

  for (const order of board.orders) {
    const existing = byPatient.get(order.patientId)
    if (!existing) {
      byPatient.set(order.patientId, {
        ...order,
        orderId: order.patientId,
        items: mergeItems(order.items),
      })
      continue
    }

    existing.itemCount += order.itemCount
    existing.items = mergeItems([...existing.items, ...order.items])
    if (!existing.profilePic && order.profilePic) {
      existing.profilePic = order.profilePic
    }
  }

  const orders = Array.from(byPatient.values())

  return {
    ...board,
    count: orders.length,
    orders,
  }
}
